/**
 * Prepare data fields
 * @param {*} fields
 * @param {*} data
 * @returns data state object
 */
export function createDataState(fields, data) {
  const dataState = {};

  // Loops through data instead
  fields.forEach((field) => {
    dataState[field] = data ? data[field] : "";
  });

  return dataState;
}
